import React, { createContext, useContext, useState, useCallback } from 'react';
import { LegendSection } from '../components/IconLegendModal';

interface IconLegendContextType {
  isOpen: boolean;
  sections: LegendSection[];
  title: string;
  openLegend: () => void;
  closeLegend: () => void;
  setLegendSections: (sections: LegendSection[], title?: string) => void;
}

const IconLegendContext = createContext<IconLegendContextType | undefined>(undefined);

export const IconLegendProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [sections, setSections] = useState<LegendSection[]>([]);
  const [title, setTitle] = useState('Icon Legend');

  const openLegend = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeLegend = useCallback(() => {
    setIsOpen(false);
  }, []);

  const setLegendSections = useCallback((newSections: LegendSection[], newTitle?: string) => {
    setSections(newSections);
    setTitle(newTitle || 'Icon Legend');
  }, []);

  return (
    <IconLegendContext.Provider
      value={{
        isOpen,
        sections,
        title,
        openLegend,
        closeLegend,
        setLegendSections,
      }}
    >
      {children}
    </IconLegendContext.Provider>
  );
};

export const useIconLegend = () => {
  const context = useContext(IconLegendContext);
  if (context === undefined) {
    throw new Error('useIconLegend must be used within an IconLegendProvider');
  }
  return context;
};
